import React from 'react';
import PageLayout from '../../components/layout/PageLayout/PageLayout';
import ComingSoonBox from '../../shared/messages/ComingSoonBox';

function FaqPage() {
  return (
    <PageLayout>
      <div style={{ padding: '80px 40px' }}>
        <h1 style={{ marginBottom: '24px' }}>자주 묻는 질문</h1>
        <ComingSoonBox />
      </div>
    {/* 기존 페이지 */}
      {/* <div style={{ padding: '80px 20px', textAlign: 'center' }}>
        <h1>자주 묻는 질문</h1>
        <p style={{ color: '#888', marginTop: 8 }}>FaqPage — 구현 예정</p>
      </div> */}
    </PageLayout>
  );
}

export default FaqPage;
